import styled from "styled-components";

export const MainButton = styled.button<{
    $backgroundColor: string;
    $textColor: string;
    $loading: boolean;
    $disabled: boolean;
    $type?: 'primary' | 'soft' | 'outline' | 'default' ;
  }>`
    width: 100%;
    padding: 4px 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    outline: none;
    border: none;
    margin: 0;
  
    background-color: ${({ $backgroundColor }) => $backgroundColor};
    color: ${({ $textColor }) => $textColor};
  
    opacity: ${({ $loading, $disabled }) =>
      $loading || $disabled ? 0.5 : 1};
  
    cursor: ${({ $loading }) =>
      $loading ? 'not-allowed' : 'pointer'};
  
    ${(props) => {
      if (props.$type === 'soft') {
        return `
          background-color: transparent;
          border: 1px solid ${props.$backgroundColor};
          color: ${props.$textColor};
          background-color: ${props.$backgroundColor}11;
        `;
      }
  
      if (props.$type === 'outline') {
        return `
          background-color: transparent;
          border: 1px solid #0E3573;
          color: #0E3573;
        `;
      }

      if (props.$type === 'default') {
        return `
          background-color: #0E3573;
          border: 1px solid #0E3573;
          color: white;
        `;
      }

      return '';
    }}
  `;